module.exports = __webpack_public_path__ + "static/img/TIME.85a99737.png";